import React, { useState, useEffect, useReducer, FC } from 'react';

// CSS
import styles from '@UILayer/UILayer.scss';

const WinlineItemPowerLine: React.FC<{ reelsNo: number }> = (data) => {
    const [state, setState] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {});

    useEffect(() => {}, [data.reelsNo]);

    return (
        <svg viewBox="0 0 690.92 149" className={styles.powerLines_item}>
            <g id="ok">
                <rect className={styles.winline_rect_bg} x="114" width={data.reelsNo === 3 ? 165 : 199} height="149" rx="12" ry="12" />
                <g>
                    <g>
                        <circle className={styles.active_dot} cx="159.25" cy="30.53" r="12.5" />
                        <circle className={styles.normal_dot} cx="159.25" cy="74.53" r="12.5" />
                        <circle className={styles.normal_dot} cx="159.25" cy="118.53" r="12.5" />
                    </g>
                    <g>
                        <circle className={styles.active_dot} cx="196.25" cy="30.58" r="12.5" />
                        <circle className={styles.normal_dot} cx="196.25" cy="74.58" r="12.5" />
                        <circle className={styles.normal_dot} cx="196.25" cy="118.57" r="12.5" />
                    </g>
                    <g>
                        <circle className={styles.normal_dot} cx="233.25" cy="30.43" r="12.5" />
                        <circle className={styles.normal_dot} cx="233.25" cy="74.42" r="12.5" />
                        <circle className={styles.active_dot} cx="233.25" cy="118.42" r="12.5" />
                    </g>

                    {data.reelsNo === 4 && (
                        <g>
                            <circle className={styles.active_dot} cx="270.25" cy="30.48" r="12.5" />
                            <circle className={styles.normal_dot} cx="270.25" cy="74.48" r="12.5" />
                            <circle className={styles.normal_dot} cx="270.25" cy="118.48" r="12.5" />
                        </g>
                    )}
                </g>
                <path
                    className={styles.pp_cls_3}
                    d="M52,30.28c23.71,0,43,19.29,43,43s-19.29,43-43,43S9,96.99,9,73.28,28.29,30.28,52,30.28M52,21.28C23.28,21.28,0,44.56,0,73.28s23.28,52,52,52,52-23.28,52-52-23.28-52-52-52h0Z"
                />
                <polyline className={styles.pp_cls_1} points="35 77.14 50.87 93.01 72.45 56.28" />
            </g>
            <g id="no_ok">
                <rect className={styles.winline_rect_bg} x="491.92" width={data.reelsNo === 3 ? 165 : 199} height="149" rx="12" ry="12" />
                <g>
                    <g>
                        <circle className={styles.active_dot} cx="537.17" cy="30.52" r="12.5" />
                        <circle className={styles.normal_dot} cx="537.17" cy="74.52" r="12.5" />
                        <circle className={styles.normal_dot} cx="537.17" cy="118.53" r="12.5" />
                    </g>
                    <g>
                        <circle className={styles.normal_dot} cx="574.17" cy="30.57" r="12.5" />
                        <circle className={styles.normal_dot} cx="574.17" cy="74.57" r="12.5" />
                        <circle className={styles.normal_dot} cx="574.17" cy="118.57" r="12.5" />
                    </g>
                    <g>
                        <circle className={styles.normal_dot} cx="611.17" cy="30.42" r="12.5" />
                        <circle className={styles.normal_dot} cx="611.17" cy="74.42" r="12.5" />
                        <circle className={styles.active_dot} cx="611.17" cy="118.42" r="12.5" />
                    </g>
                    {data.reelsNo === 4 && (
                        <g>
                            <circle className={styles.active_dot} cx="648.17" cy="30.48" r="12.5" />
                            <circle className={styles.normal_dot} cx="648.17" cy="74.47" r="12.5" />
                            <circle className={styles.normal_dot} cx="648.17" cy="118.48" r="12.5" />
                        </g>
                    )}
                </g>
                <path
                    className={styles.pp_cls_5}
                    d="M430.02,31.5c23.71,0,43,19.29,43,43s-19.29,43-43,43-43-19.29-43-43,19.29-43,43-43M430.02,22.5c-28.72,0-52,23.28-52,52s23.28,52,52,52,52-23.28,52-52-23.28-52-52-52h0Z"
                />
                <g>
                    <line className={styles.pp_cls_2} x1="411.28" y1="56.75" x2="448.76" y2="94.23" />
                    <line className={styles.pp_cls_2} x1="411.28" y1="94.23" x2="448.76" y2="56.75" />
                </g>
            </g>
        </svg>
    );
};

export default WinlineItemPowerLine;
